import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorage } from 'ngx-store';
import { AppSettings } from '../../../app.settings';
import { ToastrService } from 'ngx-toastr';
import { formatDate } from '@angular/common';
import { IMyDpOptions } from 'mydatepicker';
import { HttpClient } from '@angular/common/http';
import { switchMap, tap } from 'rxjs/operators';
import { DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';

//Model
import { Run } from '../../../model/dispatch.model';
import { Settings } from '../../../app.settings.model';
import { Url,User } from '../../../model/users.model';
import { ThemeSetting } from '../../../model/users.model';
import { FileExport } from '../../../model/exporter.model';

//Service
import { BookingsService } from '../../bookings/bookings.service';
import { DispatchService } from '../../../services/dispatch.service';
import { ExportService } from '../../../services/exporter.service';
import { DataService } from '../../../services/data.service';
import * as moment from 'moment';
import { ComponentsSettingsService} from '../../../services/components_settings.service';
import { FormBuilder } from '@angular/forms';


@Component({
  selector: 'app-manifestlist',
  templateUrl: './manifestlist.component.html',
  styleUrls: ['./manifestlist.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DispatchService, BookingsService]
})
export class ManifestlistComponent implements OnInit {
 	@LocalStorage() url: Url;
	@LocalStorage() user!: User;
	@LocalStorage() themeSettings: ThemeSetting;


	public settings: Settings;
	public searchText: string;
	public type: string = 'list';

	fleetAssign: string;
	fleetStatus: string;
	fleetFleet: string;

	public p: any;
	public going_to: any;

	showSummary: boolean = false;
	showFilters: boolean = false;
	filterType: string;
	filterValue: string;
	sub: Subscription;
	SelectionType = SelectionType;
	selected: any = [];

	totalItems: number = 0;
	totalLinehaul: number = 0;
	totalLocal: number = 0;
	totalEmptyRun: number = 0;
	totalWarehouse: number = 0; // aka PUD
	totalTowhaul: number = 0;
	totalChangeover: number = 0;

	temp = [];
	fullRows = [];
	count = 0;
	statusDropdown: string = 'all';
	dateDropdown: string = 'week';

	public locale: any = {
		format: 'DD MMMM YYYY',
		displayFormat: 'DD MMMM YYYY',
		separator: ' to ',
		cancelLabel: 'Cancel',
		applyLabel: 'OK',
	  }
	maxDate: moment.Moment = moment();

	public jobDateRange: any = [];
	public dispatchRows: Run[];


	// Dispatch Column Filters
	showWeekNo: boolean = true;
	showjobManifestlNo: boolean = true;
	showjobConnoteNo: boolean = true;
	showRunType: boolean = true;
	showRunDriver: boolean = true;
	showRunEquipment:boolean = true;
	showRunStatus: boolean = true;
	showSDPFile: boolean = true;
	showTripsheetFile: boolean = true;
	showChangeoverRun: boolean =  false;
	showTotalKlms: boolean =  false;
	showTotalDriving: boolean =  false;
	showDepartureDate: boolean =  true;
	showDepartureTime: boolean =  false;
	showArrivalDate: boolean =  true;
	showArrivalTime: boolean =  false;

	//Filter Content in Specified Column
	public filterWeekNo: string = '';
	public filterManifestNo: string = '';
	public filterConnoteNo: string = '';
	public filterRunStatus: string = '';
	public filterRunType: string = '';
	public filterRunDriver: string = '';
	public filterRunEquipments: string = '';
	public filterSDPFile: string = '';
	public filterTripsheetFile: string = '';
	public filterChangeover: string = '';
	public filterTotalKlms: string = '';
	public filterDrivingHours: string = '';
	public filterDepartureDate: any;
	public filterDepartureTime: any;
	public filterArrivalDate: any;
	public filterArrivalTime: any;

	//Misc data declerations
	public routes = []
	public run_actions = [];
	public run_types = [];
	public locations = [];
	public service_types = [];
	public states = [];
	public run_statuses = [];

	showRego: boolean = true;
	showFleetId: boolean = true;

	public folderPath: string;
	public rego: string;
	public fleetId: number;
	public fleetRego: string;
	public modalRef: NgbModalRef;
	public fleet_id: number;
	public paramsSub: Subscription;
	help: any;
	loadingIndicator: boolean = true;
	selectedrow : any;

	//Handles the name, type and content of the to-be exported file
	public exp_excel: FileExport;
	public exp_pdf: FileExport;
	//Stores the filtered and formatted content of the file
	formatted_list: any;
	spinner: boolean = false;
	undo_changeover:any;

	firstRun: number;
    secondRun: number;
	firstRunPoints: any;
    secondRunPoints: any;
	firstRunAfterPoint: number;
    secondRunAfterPoint: number;
	firstRunLat: any;
	firstRunLng: any;
	secondRunLat: any;
	secondRunLng: any;

	changeoverStreetNo: string;
    changeoverStreet: string;
    changeoverShortName: string;
    changeoverSuburb: string;
    changeoverCity: string = "";
    changeoverState: string;
    changeoverPostalCode: string;
    changeoverLat: any;
    changeoverLng: any;
    changeoverDateTime: string;        
    releaseDate: any;
    releaseStartTime: any;
	releaseFinishTime: any;
	collectDate: any;
    collectStartTime: any;
	collectFinishTime: any;
    changeoverLocation: string;
	runData:any;
	changeoverLocationString:any;
	num:any;
	num1:any;
	binding:any;
	binding1:any;

	showChangeoverAddressEntries: boolean = false;
	mapObj: any;
	public positions = [];
	legData = [];
	route_done = false;
	route_done1 = false;
	changeover_rows:any;

	checkDatetime:boolean = false;
	releaseDateCheck:boolean= true;
	time1:boolean= false;
	time2:boolean= false;
	time3:boolean= false;
	time4:boolean= false;

	changeover_delivery1:any;
	changeover_delivery2:any;
	firstChangeoverRunPoints: any;
    secondChangeoverRunPoints: any;
	release1_lat:any;
	release1_lng:any;
	release2_lat:any;
	release2_lng:any;
	changeover_callback=null;
	currentDate = new Date();

	public geofence_size_default: number = 0;
	public admin_user = this.user.id;

	@ViewChild('cancelDispatchModal', { static: false }) cancelDispatchModal: TemplateRef<any>;
	@ViewChild('undoChangeoverModal', { static: false }) undoChangeoverModal: TemplateRef<any>;
	@ViewChild('addChangeoverModal', { static: false }) addChangeoverModal: TemplateRef<any>;


	public myDatePickerOptions: IMyDpOptions = {
		// other options...
		dateFormat: 'dd mmm yyyy',
		height: '25px',
		selectionTxtFontSize: '13px',
		showTodayBtn: true,
		disableUntil: {year: this.currentDate.getFullYear(), month: this.currentDate.getMonth()+1, day: this.currentDate.getDate()-1}
	
	};
	public userSettings: any = {
		showSearchButton: false,
		inputPlaceholderText: 'Type key word on location to search',
		showCurrentLocation: false
	  };

	showAdvancedSearch = false;
	advancedSearchForm: any;
	loadingAdvancedSearch = false;

	advancedDateRangeLocale: any = {
		format: 'MMM DD YYYY',
		separator: ' - '
	}
	countServerPagination = 0;
	isFilterEmpty = true;
	isServerPagination = false;
	@ViewChild(DatatableComponent) manifestTable: DatatableComponent;

	clientSideData = [];

	constructor(private bookingsService: BookingsService, private dispatchService: DispatchService, public router: Router, public modalService: NgbModal, 
		public appSettings: AppSettings, public route: ActivatedRoute, private _Activatedroute: ActivatedRoute, private http: HttpClient,
		private data: DataService, private exporter: ExportService, private toastr: ToastrService, private modal: NgbModal, private svc_components : ComponentsSettingsService,
		private fb: FormBuilder
	) {

		this.paramsSub = this.route.params.subscribe(params => {
			this.fleet_id = params["id"];
		});
		this.settings = appSettings.settings;
	}

	ngOnInit() {
		this.initAdvancedSearchForm();
		this.sub = this._Activatedroute.params.subscribe(params => { this.filterType = params['filterType']; this.filterValue = params['filterValue'] });
		this.getData();
		this.getAllRuns();
		this.folderPath = this.url.fileStorage;
		// this.data.currentHelp.subscribe(help => this.help = help);

		//Declaration to handle the name, type and content of the file
		this.exp_excel = { title: '', list_data: '', type: '' };
		this.exp_pdf = { title: '', list_data: '', type: '' };
	}

	initAdvancedSearchForm(){
		this.advancedSearchForm = this.fb.group({
			manifest_week: [null],
			manifest_no: [null],
			connote_no: [null],
			driver: [null],
			equipment: [null],
			date_range: [null]
		});
	}

	goAdvancedSearch(event){
		this.loadingAdvancedSearch = true;
		this.filterRunType = "";
		this.filterRunStatus = "";
		this.isServerPagination = true;
		this.loadingIndicator = true;

		if(this.advancedSearchForm.value.date_range != null){
			this.advancedSearchForm.value.start = moment(this.advancedSearchForm.value.date_range.start).format('YYYY-MM-DD');
			this.advancedSearchForm.value.end = moment(this.advancedSearchForm.value.date_range.end).format('YYYY-MM-DD');
		}

		if(event != undefined){
			this.advancedSearchForm.value.limit = 30;
			this.advancedSearchForm.value.offset = event.offset == 0 ? 0 : event.offset * 30;
		}
		else{
			this.advancedSearchForm.value.limit = 30;
			this.advancedSearchForm.value.offset = 0;
		}

		this.http.post(this.url.rest + '/tms/advancedSearchLinehaulManifest', this.advancedSearchForm.value).subscribe(
			(res: any)=>{
				this.countServerPagination = res['count_results'];
				this.changeover_rows = [];
				res['runs'].forEach(data => {
					if (data.run_type_id > 1 && data.run_type_id <  5 && (data.run_status_id == 1 || data.run_status_id == 3) && data.finish_done == false && data.changeover_run_id == null) { 
					this.changeover_rows.push(data);
					}
				});
			
				res['runs'].forEach(el => {
					if(el.departure_date != null && el.departure_time != null){
						el.departure_time = moment((el.departure_date+' '+el.departure_time)).format('h:mm A');
						el.departure_date = moment(el.departure_date).format('D MMM YYYY');
					}
					if(el.arrival_date != null && el.arrival_time != null){
						el.arrival_time = moment((el.arrival_date+' '+el.arrival_time)).format('h:mm A');
						el.arrival_date = moment(el.arrival_date).format('D MMM YYYY');
					}

					if(el.total_driving_hours > 0){
						let string_hrs = (el.total_driving_hours.toString()).split(".")
						let drvHours = string_hrs[0] + " hrs " + (Number("."+string_hrs[1])*60) + " mins"
						el['drv_Hours'] = drvHours
					} else el['drv_Hours'] = "0 Hrs"
				});

				this.dispatchRows = res['runs'];
				this.fullRows = this.dispatchRows;
				setTimeout(() => { this.loadingIndicator = false; }, 500);

				this.count = Object.keys(this.dispatchRows).length;
				this.computeSummary();
				this.loadingIndicator = false;
				this.resetFilters();
			},
			(error)=>{
				this.loadingIndicator = false;
				this.loadingAdvancedSearch = false;
			},
			()=>{
				this.loadingAdvancedSearch = false;
				this.loadingIndicator = false;
			}
		);

		if(event == undefined)
			this.manifestTable._offset = 0;
	}

	resetAdvancedSearch(){
		this.isServerPagination = false;
		this.showAdvancedSearch = false;
		this.advancedSearchForm = null;
		this.initAdvancedSearchForm();
		this.dispatchRows = this.clientSideData;
		this.fullRows = this.clientSideData;
		this.computeSummary();
		this.resetFilters();
		this.count = Object.keys(this.dispatchRows).length;
	}

	ngAfterViewInit() {
		// setTimeout(() => { this.data.changeHelp(helpData["default"]); });
	}

	public openCancelDispatchModal(row) {
		this.selectedrow = row
		this.modal.open(this.cancelDispatchModal, { backdrop: 'static', size: 'xs', });
	  }

	  public openUndoChangeover(row) {
		this.undo_changeover = row
		this.modal.open(this.undoChangeoverModal, { backdrop: 'static', size: 'xs', });
	  }

	 //GET SERVICES
	 async getData() {
		await this.dispatchService.getDispatchMiscData().toPromise().then(data => {
		  console.log('misc data', data)
		  this.service_types = data['service_types'];
		  this.run_actions = data['run_actions'];
		  this.run_types = data['run_types'];
		  this.states = data['states'];
		  this.routes = data['state_routes'];
		  this.locations = data['locations'];
		  this.run_statuses = data['run_statuses'];
		  this.geofence_size_default = data['geofence_default'];
		});
	  }

	async getAllRuns(statusFilter = this.statusDropdown, dateFilter = this.dateDropdown, start = '', end= ''){
		console.time('Getting runs');
		this.dispatchService.getRuns(statusFilter = this.statusDropdown, dateFilter = this.dateDropdown, start, end ).toPromise().then(data => {
			this.dispatchRows = data;
			this.changeover_rows = [];
			this.dispatchRows.forEach(data => {
				if (data.run_type_id > 1 && data.run_type_id <  5 && (data.run_status_id == 1 || data.run_status_id == 3) && data.finish_done == false && data.changeover_run_id == null) { 
				  this.changeover_rows.push(data);
				}
			  });
		
			this.dispatchRows.forEach(el => {
				if(el.departure_date != null && el.departure_time != null){
					// let test = new Date(el.departure_date +' ' + el.departure_time);
					// el.departure_time = test.toString();
					el.departure_time = moment((el.departure_date+' '+el.departure_time)).format('h:mm A');
					el.departure_date = moment(el.departure_date).format('D MMM YYYY');
				}
				if(el.arrival_date != null && el.arrival_time != null){
					// let test =  new Date(el.arrival_date +' ' + el.arrival_time);
					// el.arrival_time = test.toString();
					el.arrival_time = moment((el.arrival_date+' '+el.arrival_time)).format('h:mm A');
					el.arrival_date = moment(el.arrival_date).format('D MMM YYYY');
				}

				if(el.total_driving_hours > 0){
					let string_hrs = (el.total_driving_hours.toString()).split(".")
					let drvHours = string_hrs[0] + " hrs " + (Number("."+string_hrs[1])*60) + " mins"
					el['drv_Hours'] = drvHours
				} else el['drv_Hours'] = "0 Hrs"

				el.equipments.sort((a,b) =>(a.is_truck > b.is_truck? -1: 1));
			});
			this.fullRows = this.dispatchRows;
			this.clientSideData = this.dispatchRows;
			console.log("RUNS:", this.dispatchRows);
			setTimeout(() => { this.loadingIndicator = false; }, 500);

			this.count = Object.keys(this.dispatchRows).length;
			this.computeSummary();
			console.timeEnd('Getting runs');
		});
	}

	public toggle(type) {
		this.type = type;
	}

	async operations(row, type){
		
		const runs =  {
            id: row.id,
            user_id: this.user['id']
        }

		if(type == 'cancelconnote'){
			this.spinner = true;
			let connotes = row.run_plan_activities;
			await this.dispatchService.cancelDispatch(runs).toPromise().then(async data => {
				if(data['status'] == false){
					this.toastr.success('', data['message'], {
						timeOut: 2000,
						positionClass: 'toast-top-full-width',
						progressBar: true
					});
					if (this.dateDropdown == 'range') {
						this.processDateRange();
					  } else this.getAllRuns();
				} else {
					this.toastr.error('', data['message'], {
						timeOut: 2000,
						positionClass: 'toast-top-full-width',
						progressBar: true
					});
				}
				this.modal.dismissAll();

				for (let i = 0; i < connotes.length; i++) {
					await this.bookingsService.cancelJob(connotes[i].id).toPromise().then(data => {
						if(data['error']!=false){
							this.toastr.error(connotes[i].control_no, data['message'], {
							timeOut: 5000,
							positionClass: 'toast-top-full-width',
							progressBar: true
							});
						}
					});
				}
			});
			


			setTimeout(() => { this.spinner = false; }, 1500);
		}

		if (type == 'view'){
			const openIn = this.router.serializeUrl(
				this.router.createUrlTree(['dispatch/manifestdetails/', row.id ])
			);
		  window.open(openIn, '_blank');
		} else if (type == 'cancel'){
			this.spinner = true;
			await this.dispatchService.cancelDispatch(runs).toPromise().then(data => {
				if(data['status'] == false){
					this.toastr.success('', data['message'], {
						timeOut: 2000,
						positionClass: 'toast-top-full-width',
						progressBar: true
					});
					if (this.dateDropdown == 'range') {
						this.processDateRange();
					  } else this.getAllRuns();
				} else {
					this.toastr.error('', data['message'], {
						timeOut: 2000,
						positionClass: 'toast-top-full-width',
						progressBar: true
					});
				}
				this.modal.dismissAll();
			});
			setTimeout(() => { this.spinner = false; }, 1500);
		}
	}

	
	async undo(row){
		row.user_id = this.user.id;
		this.loadingIndicator = true;
		this.spinner = true;
		await this.dispatchService.undoChangeover(row).toPromise().then(data => {
				this.toastr.success('', 'Undo Changeover Successfully Done!', {
						timeOut: 2000,
						positionClass: 'toast-top-full-width',
						progressBar: true
					});
					this.getAllRuns();
			}).catch(err =>{
				this.toastr.error("Please try again.", "Undo Changeover Failed.", {
				  timeOut: 5000,
				  positionClass: 'toast-top-full-width',
				  progressBar: true
				});
			  })
		setTimeout(() => { 
			this.spinner = false;
			this.modal.dismissAll(); }, 1500);
	}


	print(): void {
		let printContents, popupWin;
		printContents = document.getElementById('print-section').innerHTML;
		popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
		popupWin.document.open();
		popupWin.document.write(`
	      <html>
				<head>
	      <title>Dispatch List</title>
	      <style>
	      @page {
	        size: A4;
	      }

	      table {
	        border-collapse: collapse;
	        border-spacing: 0;
	        width: 100%;
	        border: 1px solid #ddd !important;
	    }

	    th, td {
	        text-align: left;
	        padding-bottom: 14px;
			padding-top: 14px;
			pdgging-left: 10px;
			padding-right: 10px;
	    }


	    tr:nth-child(even) {
	        background-color: #f2f2f2 !important;
	        box-shadow: inset 0 0 0 1000px #f2f2f2;
	    }

	    .fn {
	      float: footnote;
	    }

	    thead {
	      box-shadow: inset 0 0 0 1000px #f2f2f2;
	    }
	             
	    </style>
	    </head>
	    <body onload="window.print();window.close()">${printContents}</body>
	      </html>`
		);
		popupWin.document.close();
	}


	public toggleSummary() {
		if (this.showSummary) this.showSummary = false;
		else this.showSummary = true;
	}

	public toggleFilters() {
		if (this.showFilters) this.showFilters = false;
		else this.showFilters = true;
	}

	getCellClass({ row }): any {
		return {
			'is-line-dispatch-pending': row.run_status_id == 1,
			// 'is-dispatched': row.run_status_id == 2,
			'is-line-dispatch-processing': row.run_status_id == 3,
			'is-line-dispatch-completed': row.run_status_id == 4,
			'is-line-dispatch-cancelled': row.run_status_id == 5,
			// 'is-withdrawn': row.is_assigned == '0' && row.is_enabled == '0',
			// 'is-subcontracted': row.is_assigned == '0' && row.is_enabled == '0',
			// 'is-draft': row.is_assigned == '0' && row.is_enabled == '0',

		};
	}

	resetFilters() {
		this.dispatchRows = this.fullRows;
		this.computeSummary();
		
		if(this.fullRows.length){
		  this.count = this.fullRows.length
		}else{
		  this.count = 0;
		};
	
		this.isFilterEmpty = true;
	
		this.filterManifestNo='';
		this.filterConnoteNo='';
		this.filterRunStatus='';
		this.filterRunType='';
		this.filterRunDriver='';
		this.filterRunEquipments='';
		this.filterSDPFile='';
		this.filterTripsheetFile='';
		this.filterChangeover='';
		this.filterTotalKlms='';
		this.filterDrivingHours='';
		this.filterDepartureDate='';
		this.filterDepartureTime='';
		this.filterArrivalDate='';
		this.filterArrivalTime='';
	}

	sType: any = this.SelectionType.single;
	onClickStatus(status) {
		this.filterRunStatus = status;
		this.updateFilter();
		this.computeSummary();
	
		if(status == 'Completed'){
		  this.sType =  this.SelectionType.checkbox;
		  this.selected = [];
		}else{
		  this.sType =  this.SelectionType.single;
		}
	}

	onClickJobType(type) {
		this.filterRunType = type;
		this.updateFilter();
		this.computeSummary();
	
	}


	updateFilter() {
		this.temp = this.fullRows;
		this.isFilterEmpty = false;

		if(this.filterWeekNo){
			this.temp = this.temp.filter(data => {
				if (data.manifest_week)
					return data.manifest_week?.toLowerCase().indexOf(this.filterWeekNo.toLowerCase()) !== -1 || !this.filterWeekNo.toLowerCase();
			});	
		}

		if(this.filterManifestNo){
			this.temp = this.temp.filter(data => {
				if (data.control_no)
					return data.control_no?.toLowerCase().indexOf(this.filterManifestNo.toLowerCase()) !== -1 || !this.filterManifestNo.toLowerCase();
			});	
		}

		if(this.filterConnoteNo){
			
			this.temp = this.temp.filter(data => {
				if (data.run_plan_activities?.length){
					return data.run_plan_activities.some((activity)=>{
						return activity.control_no?.toLowerCase().indexOf(this.filterConnoteNo.toLowerCase()) !== -1 ;
					});
				}
			});	
		}

		if(this.filterRunStatus){
			this.temp = this.temp.filter(data => {
				if (data.run_status)
					return data.run_status?.toLowerCase().indexOf(this.filterRunStatus.toLowerCase()) !== -1 || !this.filterRunStatus.toLowerCase();
			});	
		}

		if(this.filterRunType){
			this.temp = this.temp.filter(data => {
				if (data.run_type){
					if(this.filterRunType == 'Changeover'){
						return data.changeover_run_id != null;
					}else return data.run_type?.toLowerCase().indexOf(this.filterRunType.toLowerCase()) !== -1;
				}
			});	
		}

		if(this.filterRunDriver){
			this.temp = this.temp.filter(data => {
				if (data.drivers.length){
					return data.drivers.some((driver)=>{
						return driver.first_name?.toLowerCase().indexOf(this.filterRunDriver.toLowerCase()) !== -1 || driver.last_name?.toLowerCase().indexOf(this.filterRunDriver.toLowerCase()) !== -1;
					});
				}
			});	
		}

		if(this.filterRunEquipments){
			this.temp = this.temp.filter(data => {
				if (data.equipments.length){
					return data.equipments.some(driver=>{
						return driver.rego?.toLowerCase().indexOf(this.filterRunEquipments.toLowerCase()) !== -1 || driver.rego?.toLowerCase().indexOf(this.filterRunEquipments.toLowerCase()) !== -1;
					});
				}
			});	
		}

		if(this.filterSDPFile){
			this.temp = this.temp.filter(data => {
				if (data.sdp_file)
					return data.sdp_file?.toLowerCase().indexOf(this.filterSDPFile.toLowerCase()) !== -1;
			});	
		}

		if(this.filterTripsheetFile){
			this.temp = this.temp.filter(data => {
				if (data.tripsheet_file)
					return data.tripsheet_file?.toLowerCase().indexOf(this.filterTripsheetFile.toLowerCase()) !== -1;
			});	
		}

		if(this.filterChangeover){
			this.temp = this.temp.filter(data => {
				if (data.changeover_with)
					return data.changeover_with?.toLowerCase().indexOf(this.filterChangeover.toLowerCase()) !== -1;
			});	
		}

		if (this.filterTotalKlms) {
			this.temp = this.temp.filter(data => {
				data.total_klms = data.total_klms + "";
				if (data.total_klms) 
					return data.total_klms?.indexOf(this.filterTotalKlms) !== -1;
			});
		}

		if (this.filterDrivingHours) {
			this.temp = this.temp.filter(data => {
				if (data.drv_Hours) 
					return data.drv_Hours?.toLowerCase().indexOf(this.filterDrivingHours.toLowerCase()) !== -1;
			});
		}

		if (this.filterDepartureDate) {
			this.temp = this.temp.filter(data => {
				if (data.departure_date !== null && data.departure_date !== '') 
					// return data.departure_date?.toLowerCase().indexOf(this.filterDepartureDate.toLowerCase()) !== -1;
					return data.departure_date?.indexOf(moment(this.filterDepartureDate).format('D MMM YYYY')) !== -1;
			});
		}

		if (this.filterDepartureTime) {
			this.temp = this.temp.filter(data => {
				if (data.departure_time !== null && data.departure_time !== '') 
					// return data.departure_time?.toLowerCase().indexOf(this.filterDepartureTime.toLowerCase()) !== -1;
					return data.departure_time?.indexOf(moment((data.departure_date+' '+this.filterDepartureTime)).format('h:mm A')) !== -1;
			});
		}

		if (this.filterArrivalDate) {
			this.temp = this.temp.filter(data => {
				if (data.arrival_date !== null && data.arrival_date !== '') 
					// return data.arrival_date?.toLowerCase().indexOf(this.filterArrivalDate.toLowerCase()) !== -1;
					return data.arrival_date?.indexOf(moment(this.filterArrivalDate).format('D MMM YYYY')) !== -1;
			});
		}

		if (this.filterArrivalTime) {
			this.temp = this.temp.filter(data => {
				if (data.arrival_time !== null && data.arrival_time !== '') 
					// return data.arrival_time?.toLowerCase().indexOf(this.filterArrivalTime.toLowerCase()) !== -1;
					return data.arrival_time?.indexOf(moment((data.arrival_date+' '+this.filterArrivalTime)).format('h:mm A')) !== -1;
			});
		}

		if(!this.filterWeekNo && !this.filterManifestNo && !this.filterConnoteNo && !this.filterRunStatus 
			&& !this.filterRunType && !this.filterRunDriver && !this.filterRunEquipments && !this.filterSDPFile
			&& !this.filterTripsheetFile && !this.filterChangeover && !this.filterTotalKlms && !this.filterDrivingHours
			&& !this.filterDepartureDate && !this.filterDepartureTime && !this.filterArrivalDate && !this.filterArrivalTime
		)
			this.isFilterEmpty = true;

		this.count = Object.keys(this.temp).length;
		this.dispatchRows = this.temp;
		this.computeSummary();

	}

	computeSummary() {
		this.totalItems = 0;
		this.totalLinehaul = 0;
		this.totalLocal = 0;
		this.totalEmptyRun = 0;
		this.totalChangeover = 0;
		this.totalWarehouse = 0; // aka PUD
		this.totalTowhaul = 0;

		if (this.dispatchRows.length) {
	
		  //this.rows.reduce((counter, {job_type_id}) => job_type_id == 1 ? this.totalLocal + 1 : this.totalLocal, 0);		
		for (const input of this.dispatchRows) {
			if (input.run_type_id == 1) this.totalLocal = this.totalLocal + 1;
			if (input.run_type_id == 2) this.totalLinehaul = this.totalLinehaul + 1;
			if (input.run_type_id == 3) this.totalEmptyRun = this.totalEmptyRun + 1;
			if (input.run_type_id == 4) this.totalTowhaul = this.totalTowhaul + 1;
			if (input.run_type_id == 6) this.totalWarehouse = this.totalWarehouse + 1;

			if (input.changeover_run_id != null) this.totalChangeover = this.totalChangeover + 1;
		  }
	
		}
		//this.averagePrice = (this.totalPrice / this.totalItems) || 0;
		this.totalItems = this.dispatchRows.length;
	}

	public closeModal() {
		this.modalRef.close();
		this.runData = [];
		this.legData = [];
		this.binding = [];
		this.num = [];
		this.binding1 = [];
		this.num1 = [];
		this.firstRunLat = '';
		this.firstRunLng = '';
		this.secondRunLat = '';
		this.secondRunLng = '';
		this.firstRunPoints = null;
		this.secondRunPoints = null;
		this.changeoverLocationString = "";
		this.firstRun = null;
		this.secondRun= null;
		this.firstRunAfterPoint = null;
		this.secondRunAfterPoint = null;
		this.showChangeoverAddressEntries = false;
		this.changeoverLocation = "";
		this.changeoverCity = "";
		this.changeoverPostalCode = "";
		this.changeoverState = "";
		this.changeoverStreetNo = "";
		this.changeoverStreet = "";
		this.changeoverSuburb = "";
		this.mapObj= "";
		this.changeover_callback ="";
		this.firstRunPoints = null;
		this.secondRunPoints = null;
	}

	onChangeDateDropdown(selected) {
		this.isServerPagination = false;
		if (selected != 'range') {
			this.loadingIndicator = true;
			this.getAllRuns(this.statusDropdown, selected);
		}
	}

	// sType: any = this.SelectionType.single;
	onChangeStatusDropdown(selected) {
		this.statusDropdown = selected;
		this.loadingIndicator = true;
		this.isServerPagination = false;
		if (selected) {
			if (selected == 'completed') this.dateDropdown = '7';
			if (selected == 'current') this.dateDropdown = 'all';
			// if (selected == 'forinvoice') this.dateDropdown = 'all';
			if (selected == 'cancelled') this.dateDropdown = '7';
			if (selected == 'all') this.dateDropdown = '7';
			this.getAllRuns(selected, this.dateDropdown);
		}

		if(selected == 'completed'){
			this.sType =  this.SelectionType.checkbox;
			this.selected = [];
		  }else this.sType =  this.SelectionType.single;
	}

	processDateRange() {
		this.loadingIndicator = true;
		var start = moment(this.jobDateRange.start?._d).format('YYYY-MM-DD');
		var end = moment(this.jobDateRange.end?._d).format('YYYY-MM-DD');
		console.log(start + ' to ' + end);
		this.getAllRuns(this.statusDropdown,'range',start, end);
	}

	gotoAddDispatch() {
		const openIn = this.router.serializeUrl(
			this.router.createUrlTree(['dispatch/dispatchplanner/'])
		);
		window.open(openIn, '_blank');
	}

	/*** Export... Module ***/
	//Replaces an attribute name for reading comprehension
	renameKey(obj, oldKey, newKey) {
		obj[newKey] = obj[oldKey];
		delete obj[oldKey];

	}

	//Formats readable header names in the given table
	generateHeaders(list_dispatch): any {
		const arr = JSON.parse(list_dispatch);
		arr.forEach(obj => {
			this.renameKey(obj, 'manifest_week', 'Week No');
			this.renameKey(obj, 'control_no', 'Manifest No');
			this.renameKey(obj, 'run_plan_activities', 'Connote No');
			this.renameKey(obj, 'run_status', 'Status');
			this.renameKey(obj, 'run_type', 'Job Type');
			this.renameKey(obj, 'drivers', 'Drivers');
			this.renameKey(obj, 'equipments', 'Equipments');
			// this.renameKey(obj, 'linehaul_type', 'Linehaul Type');
			this.renameKey(obj, 'sdp_file', 'SDP File');
			this.renameKey(obj, 'tripsheet_file', 'Tripsheet File');
			this.renameKey(obj, 'changeover_with', 'Changeover');
			this.renameKey(obj, 'total_klms', 'Total Distance');
			this.renameKey(obj, 'total_driving_hours', 'Total Driving Hours');
			this.renameKey(obj, 'departure_date', 'Departure Date');
			this.renameKey(obj, 'departure_time', 'Departure Time');
			this.renameKey(obj, 'arrival_date', 'Arrival Date');
			this.renameKey(obj, 'arrival_time', 'Arrival Time');
		});
		const updatedJson = JSON.stringify(arr);
		return updatedJson;
	}

	//Filters every column in the Fleet table list
	dispatch_generateColumnsWithFilter(list_fleet) {
		const arr = JSON.parse(JSON.stringify(list_fleet));
		arr.forEach(obj => {

			// Checks Job Type
			if(obj['run_type_id'] == '' || obj['run_type_id'] == null){
				obj['run_type_id'] = '-';
			}

			// Checks Linehaul Type
			// if(obj['linehaul_type'] == '' || obj['linehaul_type'] == null){
			// 	obj['linehaul_type'] = '-';
			// }else if(obj['linehaul_type'] == 'ftl'){
			// 	obj['linehaul_type'] = 'Full Truckload';
			// }else if(obj['linehaul_type'] == 'ltl'){
			// 	obj['linehaul_type'] = 'Less-than Truckload';
			// }



			// Checks for SDP file
			if(obj['sdp_file'] == '' || obj['sdp_file'] == null){
				obj['sdp_file'] = '-';
			}

			// Checks for Tripsheet file
			if(obj['tripsheet_file'] == '' || obj['tripsheet_file'] == null){
				obj['tripsheet_file'] = '-';
			}

			// Checks for Changeover
			if(obj['departure_date'] == '' || obj['departure_date'] == null){
				obj['departure_date'] = '-';
			}

			// Checks for Departure Date
			if(obj['departure_date'] == '' || obj['departure_date'] == null){
				obj['departure_date'] = '-';
			}

			// Checks for Departure Time
			if(obj['departure_time'] == '' || obj['departure_time'] == null){
				obj['departure_time'] = '-';
			}

			// Checks for Arrival Date
			if(obj['arrival_date'] == '' || obj['arrival_date'] == null){
				obj['arrival_date'] = '-';
			}

			// Checks for Arrival Date
			if(obj['arrival_time'] == '' || obj['arrival_time'] == null){
				obj['arrival_time'] = '-';
			}

			// obj['departure_date'] = formatDate(obj['departure_date'], 'dd MMM yyyy', 'en_US');
			// obj['departure_time'] = formatDate(obj['departure_time'], 'shortTime', 'en_US');
			obj['departure_date'] = moment(obj['departure_date']).format('D MMMM YYYY');

			if(obj['arrival_date'] != '-'){
				// obj['arrival_date'] = formatDate(obj['arrival_date'], 'dd MMM yyyy', 'en_US');
				// obj['arrival_time'] = formatDate(obj['arrival_time'], 'shortTime', 'en_US');
				obj['arrival_date'] = moment(obj['arrival_date']).format('D MMMM YYYY');
			}
			
			// Checks for SDP file
			if(obj['manifest_week'] == '' || obj['manifest_week'] == null){
				obj['manifest_week'] = '-';
			}

			// Join Control No, if any
			let rawData = [];
			let rawDataString = '';
			for(let i=0; i< obj['run_plan_activities']?.length; i++){
				rawData.push(obj['run_plan_activities'][i]['control_no']);
			}
			rawDataString = rawData.toString();
			obj['run_plan_activities'] = rawDataString;


			let rawDrivers = [];
			let rawDriversString = '';
			for(let i=0; i< obj['drivers']?.length; i++){
				rawDrivers.push(obj['drivers'][i]['first_name'] + ' ' + obj['drivers'][i]['last_name']);
			}
			rawDriversString = rawDrivers.toString();
			obj['drivers'] = rawDriversString;

			let rawEquipments = [];
			let rawEquipmentsString = '';
			for(let i=0; i< obj['equipments']?.length; i++){
				rawEquipments.push(obj['equipments'][i]['rego']);
			}
			rawEquipmentsString = rawEquipments.toString();
			obj['equipments'] = rawEquipmentsString;

			//remove filtered columns
			if (!this.showWeekNo) {
				delete obj['manifest_week'];
			};
			if (!this.showjobManifestlNo) {
				delete obj['control_no'];
			};
			if (!this.showjobConnoteNo) {
				delete obj['run_plan_activities'];
			};
			if (!this.showRunType) {
				delete obj['run_type'];
			};
			if (!this.showRunDriver) {
				delete obj['drivers'];
			};
			if (!this.showRunEquipment) {
				delete obj['equipments'];
			};
			if (!this.showRunStatus) {
				delete obj['run_status'];
			};
			if (!this.showSDPFile) {
				delete obj['sdp_file'];
			};
			if (!this.showTripsheetFile) {
				delete obj['tripsheet_file'];
			};
			if (!this.showChangeoverRun) {
				delete obj['changeover_with'];
			};
			if (!this.showTotalKlms) {
				delete obj['total_klms'];
			};
			if (!this.showTotalDriving) {
				delete obj['total_driving_hours'];
			};
			if (!this.showDepartureDate) {
				delete obj['departure_date'];
			};
			if (!this.showDepartureTime) {
				delete obj['departure_time'];
			};
			if (!this.showArrivalDate) {
				delete obj['arrival_date'];
			};
			if (!this.showArrivalTime) {
				delete obj['arrival_time'];
			};


			delete obj['id'];
			delete obj['uuid'];
			delete obj['is_released'];
			delete obj['created_by'];
			delete obj['updated_by'];
			delete obj['created_at'];
			delete obj['updated_at'];
			delete obj['run_routes_id'];
			delete obj['has_tba'];
			delete obj['service_type_id'];
			delete obj['admin_notes'];
			delete obj['driver_notes'];
			delete obj['dispatch_notes'];
			delete obj['is_excluded_saturday'];
			delete obj['is_excluded_sunday'];
			delete obj['is_excluded_holiday_no'];
			delete obj['excluded_holiday_dates'];
			delete obj['is_driver_fitness_for_duty_checked'];
			delete obj['is_fleet_checked'];
			delete obj['is_work_diary_submitted'];
			delete obj['is_fatigue_requirements_checked'];
			delete obj['is_location_checked'];
			delete obj['is_load_restraint_checked'];
			delete obj['is_mass_weights_checked'];
			delete obj['is_non_compliant'];
			delete obj['total_work_hours'];
			delete obj['other_work_hours'];
			delete obj['min_long_rest_hours'];
			delete obj['min_short_rest_hours'];
			delete obj['other_rest_hours'];
			delete obj['drv_Hours'];
			delete obj['release'];
			delete obj['run_status_id'];
			delete obj['finish_done'];
			delete obj['run_type_id'];
			delete obj['changeover_run_id'];
		});
		const updatedJson = JSON.stringify(arr);
		return updatedJson;
	}

	//Exports Fleet table to CSV file
	dispatch_exportToCSV() {
		if (this.dispatchRows.length > 0) {
			let with_header_format, with_column_filter;

			//generate json with filtered column
			with_column_filter = this.dispatch_generateColumnsWithFilter(this.dispatchRows);

			//generate json with format header
			this.formatted_list = this.generateHeaders(with_column_filter);

			//export to file
			let current_date = new Date();
			let csv_file = '[TMS]Dispatch_Management_' + this.formattedDate(current_date);
			this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Dispatch Management');
		}
	};

	//Exports Fleet table to PDF file
	dispatch_exportToPDF() {
		if (this.dispatchRows.length > 0) {
			let with_header_format, with_column_filter;

			//generate json with filtered column
			with_column_filter = this.dispatch_generateColumnsWithFilter(this.dispatchRows);

			//generate json with format header
			this.formatted_list = this.generateHeaders(with_column_filter);

			//export to file
			let current_date = new Date();
			let pdf_file = '[TMS]Dispatch_Management_' + this.formattedDate(current_date);
			this.exp_pdf.title = 'DISPATCH MANAGEMENT';
			this.exp_pdf.type = 'pdf';
			this.exp_pdf.list_data = this.formatted_list;
			this.exporter.exportToPDF(this.exp_pdf).subscribe(data => {
				saveAs(data, pdf_file + '.' + this.exp_pdf.type);
			});
		}
	};

	//Exports Fleet table to MS Excel file
	dispatch_exportToExcel() {
		if (this.dispatchRows.length > 0) {
			let with_header_format, with_column_filter;

			//generate json with filtered column
			with_column_filter = this.dispatch_generateColumnsWithFilter(this.dispatchRows);

			//generate json with format header
			this.formatted_list = this.generateHeaders(with_column_filter);

			//export to file
			console.log("IWASHERE1");
			let current_date = new Date();
			let excel_file = '[TMS]Dispatch_Management_' + this.formattedDate(current_date);
			this.exp_excel.title = 'DISPATCH MANAGEMENT';
			this.exp_excel.type = 'xlsx';
			this.exp_excel.list_data = this.formatted_list;
			this.exporter.exportToExcel(this.exp_excel).subscribe(data => {

				saveAs(data, excel_file)
			});
		}
	};

	//Returns a date format in the file name
	public formattedDate(d = new Date) {
		console.log("DDD", d);
		let month = String(d.getMonth() + 1);
		let day = String(d.getDate());
		const year = String(d.getFullYear());

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		return `${day}/${month}/${year}`;
	}

	getTotalJobsForChangeover() {
		length = this.dispatchRows.filter(function(item){
		  return item.run_type_id > 1 && item.run_type_id < 5  && (item.run_status_id == 1 || item.run_status_id == 3) &&  item.finish_done == false  && item.changeover_run_id == null;
	  }).length;
		return length;
	}

	//ADD CHANGEOVERMODAL
	openModalAddChangeover(): void {
		this.legData = [];
		this.binding = [];
		this.runData=[];
		this.num = [];
		this.firstRunLat = '';
		this.firstRunLng = '';
		this.secondRunLat = '';
		this.secondRunLng = '';
	
		this.changeoverLocationString = "";
		this.firstRun = null;
		this.secondRun= null;
		this.firstRunAfterPoint = null;
		this.secondRunAfterPoint = null;
		this.changeoverLocation = "";
		this.changeoverCity = "";
		this.changeoverPostalCode = "";
		this.changeoverState = "";
		this.changeoverStreetNo = "";
		this.changeoverStreet = "";
		this.changeoverSuburb = "";
	
		// initialize date and time
		let d: Date = new Date();
	
		for(var i=1 ;i<=4;i++)
		{
			var quarter_min = Math.ceil((d.getMinutes() / 15)) *15 +(i*15);
			var d2 = new Date(d.getTime() + (quarter_min - d.getMinutes()) *60000);
		}
	
		var hours = (d2.getHours()%24) -1;
		var minutes = d2.getMinutes();
		if (hours == -1) hours = 11;
		this.releaseDate = { date: {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()}};
		this.releaseStartTime = { hour: hours , minute: minutes };
		this.releaseFinishTime = { hour: hours , minute: minutes };
		this.collectDate = { date: {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()}};
		this.collectStartTime = { hour: hours , minute: minutes };
		this.collectFinishTime = { hour: hours , minute: minutes };
		this.modalRef = this.modal.open(this.addChangeoverModal, {size: 'lg', backdrop: 'static'});
	}

	//1st PICKUP POINTS
	async onSelectFirstJob(runId: number) {
		this.firstRunPoints = null;
		this.changeover_delivery1 = runId;
		if (this.firstRun == this.secondRun)
		  this.secondRun = null;
		const postData = {
		  run_id: runId,
		}
		await this.dispatchService.getPickupPoints(postData).toPromise().then(data => {
			this.firstRunPoints = data['points'];
			this.setPoint(this.firstRunPoints[0])
		});
	}

	//Changeover2 Delivery Points
	async onSelectChangeover1() {
		this.firstChangeoverRunPoints = null;
		const postData = {
			run_id: this.changeover_delivery2,
		}
		await this.dispatchService.getDeliveryRunPoints(postData).toPromise().then(data => {
			this.firstChangeoverRunPoints = data['points'];
			this.release1_lat = data['points'][0].lat;
			this.release1_lng= data['points'][0].lng;
			this.onSelectChangeover2();
		});
	
	}


	setPoint(data1) {
		this.firstRunPoints.forEach(data => {
		  if (data.id == data1.id) { 
			this.firstRunLat = data.lat;
			this.firstRunLng = data.lng;
		  }
		});
		if(this.changeover_callback != null){
			this.addChangeoverCallback(this.changeover_callback);
		}
	  }

	hasLocationString() {
		if (this.changeoverLocationString && this.changeoverLocationString !='' && this.changeoverLocation != null)
			return true;
		else return false;
	}

	//2nd PICKUP POINTS
	async onSelectSecondJob(runId: number) {
		this.secondRunPoints = null;
		this.changeover_delivery2= runId;
		const postData = {
			run_id: runId,
		}
		await this.dispatchService.getPickupPoints(postData).toPromise().then(data => {
			this.secondRunPoints = data['points'];
			this.setPoint2(this.secondRunPoints[0]);
		});
	}

	setPoint2(data1) {
		this.secondRunPoints.forEach(data => {
		  if (data.id == data1.id) { 
			this.secondRunLat = data.lat;
			this.secondRunLng = data.lng;
		  }
		});
		if(this.changeover_callback != null){
			this.addChangeoverCallback(this.changeover_callback);
		}
	}

	async onSelectChangeover2() {
		this.secondChangeoverRunPoints = null;
		const postData = {
		  run_id: this.changeover_delivery1,
		}
		await this.dispatchService.getDeliveryRunPoints(postData).toPromise().then(data => {
			this.secondChangeoverRunPoints = data['points'];
			this.release2_lat = data['points'][0].lat;
			this.release2_lng = data['points'][0].lng;
			this.changeoverReleaseLocation();
		});
	  
	}

	async addChangeoverCallback(selectedData:any) {
		this.legData = [];
		
		this.changeoverLocationString ='';
		this.changeover_callback = selectedData;
		this.route_done = true;
		if (selectedData)
		  this.showChangeoverAddressEntries = true;
		else
		  this.showChangeoverAddressEntries = false;
	  
		  console.log('Adding changeover....');
	  
		  if (typeof selectedData === 'string' || selectedData instanceof String){
		  	this.changeoverLocationString = selectedData;
		  }
	 	 else
		  {
			this.changeoverLocationString = JSON.stringify(selectedData);
		  }
	  
		 if (selectedData) {
	  
			this.mapObj = JSON.parse(this.changeoverLocationString);
			this.mapObj = this.mapObj.data;
		
			this.changeoverLat = this.mapObj.geometry.location.lat;
			this.changeoverLng = this.mapObj.geometry.location.lng;
			
		
		
			var arr = [];
			
			arr[0] = this.changeoverLat;
			arr[1] = this.changeoverLng;
			
			this.positions = arr;
			
			for(let result of this.mapObj.address_components){
				if (result.types == "street_number")
					this.changeoverStreetNo = result.short_name;
				if (result.types == "route")
					this.changeoverStreet = result.short_name;
				if ( result.types.includes("locality") ) 
					this.changeoverSuburb = result.short_name;
				if ( result.types.includes("administrative_area_level_2") ) 
					this.changeoverCity = result.short_name;
				if ( result.types.includes("administrative_area_level_1") ) 
					this.changeoverState = result.short_name;
				if ( result.types.includes("postal_code") ) 
					this.changeoverPostalCode = result.short_name;
			}
		
			this.changeoverLocation = this.mapObj.formatted_address;
			const pointData = [
				{
					lat1: this.firstRunLat,
					long1: this.firstRunLng,
					lat2: this.changeoverLat,
					long2: this.changeoverLng,
				},
				{
					lat1: this.secondRunLat,
					long1: this.secondRunLng,
					lat2: this.changeoverLat,
					long2: this.changeoverLng,
				}];
			const routes = await this.http.post(this.url.rest  + '/tms/getRunRoutes', pointData[0], { responseType: 'json' })
			.pipe(
				tap(data => {
				this.legData[0] = data['run_data'];
				}),
				switchMap(() => {
					return this.http.post(this.url.rest  + '/tms/getRunRoutes', pointData[1], { responseType: 'json' })
				.pipe(
				tap(data => {
					this.legData[1] = data['run_data'];
					this.preselectionLegRoute(this.legData);
				})
				)
				})
			);
			this.onSelectChangeover1();
			routes.toPromise();
			}
			else {
				var arr2 = [];
				arr2[0] = 0;
				arr2[1] = 0;
				this.positions = arr2;
			}
	  }

	async changeoverReleaseLocation() {
		  this.binding1 = [];
		  this.runData = [];

		  this.route_done1 = true;
		  const pointData = [
			{
			  lat1: this.changeoverLat,
			  long1: this.changeoverLng,
			  lat2: this.release1_lat,
			  long2: this.release1_lng,
			},
			{
				lat1: this.changeoverLat,
				long1: this.changeoverLng,
				lat2: this.release2_lat,
				long2: this.release2_lng,
			}];
			
		  const routes = await this.http.post(this.url.rest  + '/tms/getRunRoutes', pointData[0], { responseType: 'json' })
		  .pipe(
			tap(data => {
			  this.runData[0] = data['run_data'];
			}),
			switchMap(() => {
			  return this.http.post(this.url.rest  + '/tms/getRunRoutes', pointData[1], { responseType: 'json' })
			.pipe(
			  tap(data => {
				this.runData[1] = data['run_data'];
				this.preselectionLegRoute1(this.legData);
			  })
			)
			})
		  );
		  routes.toPromise();
	  }

	  

	  preselectionLegRoute(data) {
		let num = [];
		let store = [];
		for (let i = 0; i < data.length; i++) {
			for (let index = 0; index < data[i].length; index++) {
				store[index] = data[i][index]['est_total_klms'];
				if (index == data[i].length - 1) {
					store.splice(index + 1, data[i].length - index);
				}
			}
			num[i] = Math.min(...store);
			for (let index = 0; index < store.length; index++) {
				if (store[index] === num[i]) {
					num[i] = index;
					this.binding[i] = index;
				}
			}
			this.num = num;
			this.route_done = false;
		}
	  }

	  preselectionLegRoute1(data) {
		let num1 = [];
		let store1 = [];
		for (let x = 0; x< data.length; x++) {
			for (let index = 0; index < data[x].length; index++) {
				store1[index] = data[x][index]['est_total_klms'];
				if (index == data[x].length - 1) {
					store1.splice(index + 1, data[x].length - index);
				}
			}
			num1[x] = Math.min(...store1);
			for (let index = 0; index < store1.length; index++) {
				if (store1[index] === num1[x]) {
					num1[x] = index;
					this.binding1[x] = index;
				}
			}
			this.num1 = num1;
			this.route_done1 = false;
		}
	  }

	  public checkDates(){
		this.checkDatetime = true;
		this.releaseDateCheck = true;
		this.time1 = true;
		this.time2 = true;
		this.time3 = true;
		this.time4 = true;

		let releaseDate = {
		  "date": this.releaseDate,
		  "starttime": this.releaseStartTime,
		  "endtime": this.releaseFinishTime
		}
		let collectDate = {
		  "date": this.collectDate,
		  "starttime": this.collectStartTime,
		  "endtime": this.collectFinishTime
		}

		if(collectDate.date.date['year'] < releaseDate.date.date['year']){
			this.checkDatetime = false;
			this.releaseDateCheck = false;
		}

		if (collectDate.date.date['year'] == releaseDate.date.date['year']){
			if(releaseDate.date.date['month'] > collectDate.date.date['month']){
				this.checkDatetime = false;
				this.releaseDateCheck = false;
			}
			else if(releaseDate.date.date['month'] == collectDate.date.date['month'] ){
				if(releaseDate.date.date['day'] > collectDate.date.date['day']){
					this.checkDatetime = false;
					this.releaseDateCheck = false;
				}
			}
		}

		if(collectDate.date.date['year'] == releaseDate.date.date['year'] && releaseDate.date.date['month'] == collectDate.date.date['month'] && releaseDate.date.date['day'] <collectDate.date.date['day'] && releaseDate.starttime.hour > releaseDate.endtime.hour ){
					this.checkDatetime = false;
		}

		
		if(collectDate.date.date['year'] == releaseDate.date.date['year'] && releaseDate.date.date['month'] == collectDate.date.date['month'] && releaseDate.date.date['day'] <collectDate.date.date['day'] && collectDate.starttime.hour > collectDate.endtime.hour){
				this.checkDatetime = false;	
		}

		if(collectDate.date.date['year'] == releaseDate.date.date['year'] && releaseDate.date.date['month'] == collectDate.date.date['month'] && releaseDate.date.date['day'] <collectDate.date.date['day'] && releaseDate.starttime.hour == releaseDate.endtime.hour ){
			if (releaseDate.starttime.minute >= releaseDate.endtime.minute ){
				this.checkDatetime = false;
			}
		}

	
	if(collectDate.date.date['year'] == releaseDate.date.date['year'] && releaseDate.date.date['month'] == collectDate.date.date['month'] && releaseDate.date.date['day'] <collectDate.date.date['day'] && collectDate.starttime.hour == collectDate.endtime.hour){
		if (collectDate.starttime.minute >= collectDate.endtime.minute ){
			this.checkDatetime = false;
		}
	}


		if(collectDate.date.date['year'] == releaseDate.date.date['year'] && releaseDate.date.date['month'] == collectDate.date.date['month'] && releaseDate.date.date['day'] == collectDate.date.date['day'] &&  (releaseDate.starttime.hour > releaseDate.endtime.hour  || releaseDate.starttime.hour > collectDate.starttime.hour||
			releaseDate.starttime.hour > collectDate.endtime.hour|| releaseDate.endtime.hour > collectDate.starttime.hour || releaseDate.endtime.hour > collectDate.endtime.hour || collectDate.starttime.hour > collectDate.endtime.hour) ){
				this.checkDatetime = false;
		}

		if (releaseDate.date.date['year'] == collectDate.date.date['year'] && releaseDate.date.date['month'] == collectDate.date.date['month'] && releaseDate.date.date['day'] == collectDate.date.date['day'] &&(releaseDate.starttime.hour == releaseDate.endtime.hour)){
				if (releaseDate.starttime.minute >= releaseDate.endtime.minute ){
					this.checkDatetime = false;
					this.time1 = false;
				}
		}

		if (releaseDate.date.date['year'] == collectDate.date.date['year'] && releaseDate.date.date['month'] == collectDate.date.date['month'] && releaseDate.date.date['day'] == collectDate.date.date['day'] &&(releaseDate.endtime.hour == collectDate.starttime.hour)){
			if (releaseDate.endtime.minute > collectDate.starttime.minute ){
				this.checkDatetime = false;
				this.time2= false;
			}
			
		}

		if (releaseDate.date.date['year'] == collectDate.date.date['year'] && releaseDate.date.date['month'] == collectDate.date.date['month'] && releaseDate.date.date['day'] == collectDate.date.date['day'] &&(collectDate.starttime.hour == collectDate.endtime.hour)){
			if (collectDate.starttime.minute >= collectDate.endtime.minute ){
				this.checkDatetime = false;
				this.time3 = false;
			}
			
		}
	  }

	  async onSaveChangeover() {
			this.loadingIndicator = true;
			this.spinner = true;
			var total_klms1 = this.legData[0][this.binding[0]].est_total_klms + this.runData[0][this.binding[0]].est_total_klms;
			var total_klms2 = this.legData[1][this.binding[1]].est_total_klms + this.runData[1][this.binding[1]].est_total_klms;
			var total_driving_hrs1= this.legData[0][this.binding[0]].est_total_hrs + this.runData[0][this.binding[0]].est_total_hrs;
			var total_driving_hrs2= this.legData[1][this.binding[1]].est_total_hrs + this.runData[1][this.binding[1]].est_total_hrs;

			const changeoverData = {
				run1_id: this.changeover_delivery1,
				run1_total_klms: total_klms1,
				run1_total_driving_hours: total_driving_hrs1,
				run2_id: this.changeover_delivery2,
				run2_total_klms: total_klms2,
				run2_total_driving_hours: total_driving_hrs2,
				street_no: this.changeoverStreetNo,
				street: this.changeoverStreet,
				suburb: this.changeoverSuburb,
				city: this.changeoverCity,
				state: this.changeoverState,
				postal_code: this.changeoverPostalCode,
				lat: this.changeoverLat,
				lng: this.changeoverLng,
				release_start_datetime:this.releaseDate.date.year + '-' + this.releaseDate.date.month.toString().padStart(2,'0') + '-' + this.releaseDate.date.day.toString().padStart(2,'0') + ' ' + this.releaseStartTime.hour.toString().padStart(2,'0') + ':' + this.releaseStartTime.minute.toString().padStart(2,'0') + ':00',
				release_finish_datetime:this.releaseDate.date.year + '-' + this.releaseDate.date.month.toString().padStart(2,'0') + '-' + this.releaseDate.date.day.toString().padStart(2,'0') + ' ' +  this.releaseFinishTime.hour.toString().padStart(2,'0') + ':' + this.releaseFinishTime.minute.toString().padStart(2,'0') + ':00',
				collect_start_datetime:this.collectDate.date.year + '-' + this.collectDate.date.month.toString().padStart(2,'0') + '-' + this.collectDate.date.day.toString().padStart(2,'0') + ' ' +  this.collectStartTime.hour.toString().padStart(2,'0') + ':' + this.collectStartTime.minute.toString().padStart(2,'0') + ':00',
				collect_finish_datetime: this.collectDate.date.year + '-' + this.collectDate.date.month.toString().padStart(2,'0') + '-' + this.collectDate.date.day.toString().padStart(2,'0') + ' ' +  this.collectFinishTime.hour.toString().padStart(2,'0') + ':' + this.collectFinishTime.minute.toString().padStart(2,'0') + ':00',
				user_id: this.user.id,
				geofence        : [{
					radius      : this.geofence_size_default,
					created_by  : this.admin_user
				}]
			};

			await this.dispatchService.addChangeover(changeoverData).subscribe(data => {
				if(data['added'] == 'true'){
						this.toastr.success('', data['message'], {
						timeOut: 5000,
						positionClass: 'toast-top-full-width',
						progressBar: true
						});
				}
				else{
					this.toastr.success('', data['message'], {
						timeOut: 5000,
						positionClass: 'toast-top-full-width',
						progressBar: true
						});
				}
			  console.log(data);
			  this.getAllRuns();
			}, error=>{
			  this.toastr.error("Please try again.", "There was a problem with adding the selected job for changeover", {
				timeOut: 5000,
				positionClass: 'toast-top-full-width',
				progressBar: true
			  });
			});
			setTimeout(() => { 
				this.spinner = false;
				this.closeModal(); 
			}, 1500);
	  }

	isEnabled(name){
		let is_enabled = false;
		is_enabled = this.svc_components.isComponentEnabled(name);
		return is_enabled
	}

	hasComputedRoutes(){
		var to_disable = true; 
		if(this.legData[0]?.length > 0 && this.runData[0]?.length > 0 && this.legData[1]?.length > 0 && this.runData[1]?.length > 0){
			if(this.legData[0][0].est_total_hrs > 0 && this.runData[0][0].est_total_hrs > 0 && this.legData[1][0].est_total_hrs > 0 && this.runData[1][0].est_total_hrs > 0){
				to_disable = false;
			}
		};
		return to_disable;
	}

}
